import React from 'react'
import Modal from '../../components/Template/Modal'
import { useTranslation } from 'react-i18next'
import styled from '../../theme'
import { FiX } from 'react-icons/fi'
import { ILicense, LicenseType } from '../../models/License'
import Button from '../../components/Template/Button'
import { UserAccountActions } from '../../reducers/userAccount/actionNames'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveLicense, isNewPremiumLicenseValid } from '../../reducers/userAccount/selectors/license'
import { isUserNewPackage } from '../../reducers/userAccount/selectors/userAccount'
import { getPanelUrlForEnv } from '../../utils/ApiUrl'
import { getAccessToken } from '../../reducers/userAccount/selectors/credentials'


function PremiumModal({ open, close, id, license, end }: IPremiumModal) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const currentPlan = useSelector(getActiveLicense)
  const newPremium = useSelector(isNewPremiumLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isNewPremiumUser = newPremium && isNewPremiumPriceGroup
  const key = useSelector(getAccessToken)
  const deleteSub = () => {
    dispatch({ type: UserAccountActions.RequestCancelSub, id })
    close()
    if ('routerHistory' in window) {
      const today = new Date();
      const start = new Date('2025-11-25'); 
      const end = new Date('2025-12-01');   
      const isInRange = today >= start && today <= end;
      if (isInRange) {
        setTimeout(() => {
              window.location.href =
                `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`;
            }, 2000);
    }
   //   ;(window as any).routerHistory.push('/', {})
  }
  }
  const isLiteUser =
    isNewPremiumUser && currentPlan.licenseType === LicenseType.LICENSE_PREMIUM_LITE
  const isPlusUser =
    isNewPremiumUser && currentPlan.licenseType === LicenseType.LICENSE_PREMIUM_PLUS
  const isProUser =
    isNewPremiumUser && currentPlan.licenseType === LicenseType.LICENSE_PREMIUM_PRO
  const isMaxUser =
    isNewPremiumUser && +currentPlan.licenseType === LicenseType.LICENSE_PREMIUM_MAX
  return (
    <Modal
      style={{
        maxWidth: '707px',
        width: '100vw',
        margin: '0',
        maxHeight: '100vh',
        borderRadius: '4px',
      }}
      open={open}
      onClose={close}
    >
      <Header>
        <Text>{t('BED_26058_cancel_your_subscription_question')}</Text>
        <FiX onClick={close} style={{ cursor: 'pointer' }} />
      </Header>
      <Content>
        <Text2
          style={{ marginBottom: '18px', marginTop: '18px', fontSize: '14px' }}
        >
          {t('BED_26058_premium_cancel_date_text')}&nbsp;{end}.
        </Text2>
        {!isNewPremiumUser && (
          <Text2 style={{ marginBottom: '18px' }}>
            {t('BED_26058_you_will_loose_access')}
          </Text2>
        )}
        {isNewPremiumUser && (
          <Text2 style={{ marginBottom: '10px', fontWeight: 700 }}>
            {t('BED_28968_features_unavailable_after_cancel')}
          </Text2>
        )}
        <ul
          style={{
            paddingLeft: '38px',
          }}
        >

          {!isNewPremiumUser && (
            <Item>{t('BED_26058_reservations_without_limit')}</Item>
          )}
          {!isNewPremiumUser && (
            <Item>{t('BED_26058_sales_channel_no_commision')}</Item>
          )}
          {!isNewPremiumUser && (
            <Item>{t('BED_26058_ability_invoices_and_receipts')}</Item>
          )}
          {!isNewPremiumUser && (
            <Item>{t('BED_26058_connection_overbooking')}</Item>
          )}
          {!isNewPremiumUser && (
            <Item>{t('BED_26058_employee_management')}</Item>
          )}
          {(isLiteUser || isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_lite_list_1')}</Item>
          )}
          {(isLiteUser || isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_lite_list_2')}</Item>
          )}
          {(isLiteUser || isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_lite_list_3')}</Item>
          )}

          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_1')}</Item>
          )}
          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_2')}</Item>
          )}
          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_3')}</Item>
          )}
          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_4')}</Item>
          )}
          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_5')}</Item>
          )}
          {(isPlusUser || isProUser || isMaxUser) && (
            <Item>{t('OUT_5846_plus_list_6')}</Item>
          )}

          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_1')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_2')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_3')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_4')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_5')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_6')}</Item>}
          {(isProUser || isMaxUser) && <Item>{t('OUT_5846_pro_list_7')}</Item>}

          {isMaxUser && <Item>{t('OUT_5846_max_list_1')}</Item>}
          {isMaxUser && <Item>{t('OUT_5846_max_list_2')}</Item>}
          {isMaxUser && <Item>{t('OUT_5846_max_list_3')}</Item>}
          {isMaxUser && <Item>{t('OUT_5846_max_list_4')}</Item>}
          {isMaxUser && <Item>{t('OUT_5846_max_list_5')}</Item>}
          {isMaxUser && <Item>{t('OUT_5846_max_list_6')}</Item>}
        </ul>
        <ButtonWrapper>
          <Button outline={true} onClick={close}>
            {t('BED_26058_no_button')}
          </Button>
          <Button
            style={{
              marginLeft: '18px',
            }}
            adelete={true}
            onClick={deleteSub}
          >
            {t('BED_26058_yes_cancel_sub_button')}
          </Button>
        </ButtonWrapper>
      </Content>
    </Modal>
  )
}

const ButtonWrapper = styled.div`
  margin-top: 75px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`

const Item = styled.li`
  color: #272728;

  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 171.429% */
  letter-spacing: 0.042px;
`

const Content = styled.div`
  margin-top: 14px;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 14px;
  border-bottom: 1px solid #d7d7d7;
`

const Text2 = styled.div`
  color: #272728;

  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.042px;
`

const Text = styled.div`
  color: #d83a3a;

  font-family: Montserrat, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.042px;
`

export interface IPremiumModal {
  open: boolean
  close: () => void
  id: string
  license: ILicense
  end: string
}

export default PremiumModal
